import { useMemo } from "react";

import { getPaymentTypeTitle } from "../utils/common";
import { EXTERNAL_SUBSCRIPTION_DETAILS } from "../utils/common/contants";
import { EXTERNAL_SP_LIST } from "../constants/spCode";
import { IBillingInfo } from "../services/api/user/types";

interface IUsePaymentTypePayload {
  billingInfo?: IBillingInfo;
  spCode?: string;
}

export function usePaymentType({
  billingInfo,
  spCode,
}: IUsePaymentTypePayload) {
  return useMemo(() => {
    if (!spCode) {
      return "";
    }
    const isExternalPayment = EXTERNAL_SP_LIST.includes(spCode);
    return isExternalPayment && !billingInfo
      ? EXTERNAL_SUBSCRIPTION_DETAILS[spCode].label
      : getPaymentTypeTitle(billingInfo?.payment_info);
  }, [billingInfo, spCode]);
}
